import categories from './categories';
import fields from './fields';

export default {
  /**
   * Set up the Algolia credentials
   */
  algolia_app_id: '8VOK4WOPYE',
  algolia_api_key: 'a32630f310e8bde72e07a235bdadda86',
  algolia_index: 'ARL-FRFX-BOB',

  /**
   * Set up Analytics info for tracking survey responses
   */
  analytics_id: 'UA-130768066-4',

  /**
   * Set up the Google Sheet information so it can make requests to the right place
   */
  google_sheet_title: 'ARL-FRFX-BoB-2019-DB',

  /**
   * The expiration date of the survey, where no more submissions will be accepted
   * Format: 'July 3, 2018'
   */
  expiration_date: 'February 29, 2019',

  /**
   * Set some variables for the display of the survey
   */
  survey_title: 'Arlington/Fairfax Best of Business',
  survey_subtitle: 'Reader\'s Choice Awards',
  social_title: 'Cast your vote for the Best in Arlington/Fairfax!',
  publication_logo: 'https://s3-us-west-2.amazonaws.com/sungazettevoting.com/sungazette_logo.png',
  welcome_title: 'Welcome!',
  welcome: 'Welcome to the Best in Arlington/Fairfax ballot, brought to you by Sun Gazette newspaper. Cast your vote for at least 10 of your favorite business categories!',
  rules: [
    'You may only submit one ballot per year.',
  ],
  categories,
  fields,
  votes_per_category: 3,
  write_in_limit: 10,
  vote_requirement: 1,

  /**
   * Set some defaults for values that get manipulated while the survey is being filled out
   */
  vote_count: 0,
};
